module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/glyphicons-halflings-regular.woff
// module id = vF4E
// module chunks = 0